export default __webpack_public_path__ + "static/media/3-1-4.ce34d6c2.webp";